import { Component } from '@angular/core';
import { forkJoin } from 'rxjs';
import { MemberInfoComponent } from './member-info/member-info.component';
import { ScoreComponent } from './score/score.component';
import { LabReportsComponent } from './lab-reports/lab-reports.component';
import { GlucoseComponent } from './glucose/glucose.component'; 
import { LifeStyleComponent } from './life-style/life-style.component';
import { SleepComponent } from './sleep/sleep.component';
import { ActivityComponent } from './activity/activity.component';
import { CombinedMetricsComponent } from './metrics/combined-metrics.component';
import { InsightComponent } from './insights/insights.component';
import { TimeLineComponent } from './timelines/timelines.component';
import { GlucoseSummaryComponent } from './glucose/glucose-summary/glucose-summary.component';
import { MemberDashboardService } from './member-dashboard.service';
import { ActivatedRoute,RouterLink } from '@angular/router';
import {formatDate} from '@angular/common';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatLabel } from '@angular/material/form-field';
import { MatHint } from '@angular/material/form-field';
import { MatDateRangeInput } from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BMIChartComponent } from './bmi/bmi-chart.component';
import { ScoreChartComponent } from './score-chart/score-chart.component';
import { Router } from "@angular/router";
import { environment } from '../../environments/environment';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MoodCheckinComponent } from './mood-checkin/mood-checkin.component';
import { QuestsComponent } from './quests/quests.component';
import { BreathworkComponent } from './breathwork/breathwork.component';
import { MindfulnessSessionsComponent } from './mindfulness-sessions/mindfulness-sessions.component';
import { MemberJournalComponent } from './member-journal/member-journal.component';
import { BloodReportHistoryComponent } from './blood-report-history/blood-report-history.component';
import { ToastService } from '../../app/services/toast.service';
import { HabitsComponent } from './habits/habits.component';
import { WaterLogComponent } from './water-log/water-log.component';
@Component({
  selector: 'app-member-dashboard',
  standalone: true,
  imports: [MemberInfoComponent,ScoreComponent,LabReportsComponent,GlucoseComponent,LifeStyleComponent,SleepComponent,
            ActivityComponent,CombinedMetricsComponent,MatInputModule,MatNativeDateModule,MatDateRangeInput,MatHint,MatLabel,MatFormFieldModule,
            MatDatepickerModule,InsightComponent,CommonModule,TimeLineComponent,GlucoseSummaryComponent,FormsModule,BMIChartComponent,
            ScoreChartComponent,RouterLink,MatProgressSpinnerModule,MoodCheckinComponent,QuestsComponent,BreathworkComponent,MindfulnessSessionsComponent,MemberJournalComponent,HabitsComponent,MatPaginatorModule,BloodReportHistoryComponent,WaterLogComponent],
  templateUrl: './member-dashboard.component.html',
  styleUrl: './member-dashboard.component.css'
})
export class MemberDashboardComponent {
  
memberList:any=[];
scores:any=[];
labList:any=[];
lifeStyle:any=[];
activity:any=[];
sleep:any=[];
glucoseDetails:any=[];
glucoseSummary:any;
glucoseMedicinesRange:any={};
// healthMetrics data for the Glucose Mapping tab's own date range (separate from the
// Lifestyle tab's `healthMetrics` field, which has its own independent date picker).
glucoseHealthMetricsData: any = null;
insights:any=[];
timeLines:any=[];
currentDate:any;
previousDate:any;
currentDateGS:any;
currentDateNU:any;
previousDateNU:any;
previousDateSL:any;
currentDateSL:any;
previousDateAC:any;
currentDateAC:any;
previousDateBmi:any;
currentDateBmi:any;
previousDateScore:any;
currentDateScore:any;
previousDateSleep:any;
currentDateSleep:any;
previousDateActivity:any;
currentDateActivity:any;
isLoading:any=1;
 endDate:any = formatDate(Date.now(), 'yyyy-MM-dd', 'en');
 startDate:any = formatDate(new Date().setDate(new Date().getDate()-1), 'yyyy-MM-dd', 'en');
 endDateBmi:any = formatDate(Date.now(), 'yyyy-MM-dd', 'en');
 startDateBmi:any = formatDate(new Date().setDate(new Date().getDate()-7), 'yyyy-MM-dd', 'en');
 endDateScore:any = formatDate(Date.now(), 'yyyy-MM-dd', 'en');
 startDateScore:any = formatDate(new Date().setDate(new Date().getDate()-7), 'yyyy-MM-dd', 'en');
 endDateSleep:any = formatDate(Date.now(), 'yyyy-MM-dd', 'en');
 startDateSleep:any = formatDate(new Date().setDate(new Date().getDate()-7), 'yyyy-MM-dd', 'en');
 endDateActivity:any = formatDate(Date.now(), 'yyyy-MM-dd', 'en');
 startDateActivity:any = formatDate(new Date().setDate(new Date().getDate()-7), 'yyyy-MM-dd', 'en');
memberId:any=this.route.snapshot.queryParamMap.get('memberId');
  hydrationGoalData: any;
  vitalDetails: any;
  deviceInfo: any;
  planStatus: any;
  bmiWeightType: any = 1;
  weightByKg: any = [];
  kgWeight: any = [];
  weightByPound: any = [];
  BMIVals: any = [];
  bmiDetails: any = [];
  bmiValues: any = [];
  stateObj: any;
  // Active button tracking for each section
  activeButtonGlucose: string | null = null;
  activeButtonBmi: string | null = null;
  activeButtonScore: string | null = null;
  activeButtonNutrition: string | null = null;
  activeButtonSleep: string | null = null;
  activeButtonActivity: string | null = null;
  selectedMainTab: 'scores' | 'glucose' | 'vitals' | 'lifestyle' | 'mindpillar' | 'bloodreporthistory' = 'scores';
  selectedLifestyleTab: 'nutrition' | 'sleep' | 'activity' | 'metrics' | 'waterlog' = 'nutrition';
  selectedMindPillarTab: 'quests' | 'moodcheckin' | 'breathwork' | 'mindfulness' | 'journal' | 'habits' = 'quests';
  mindfulnessData: any;
  // Quests, Mindfulness, and Breathwork date tracking
  startDateQuests: any = formatDate(new Date().setDate(new Date().getDate()-7), 'yyyy-MM-dd', 'en');
  endDateQuests: any = formatDate(Date.now(), 'yyyy-MM-dd', 'en');
  startDateMindfulness: any = formatDate(new Date().setDate(new Date().getDate()-7), 'yyyy-MM-dd', 'en');
  endDateMindfulness: any = formatDate(Date.now(), 'yyyy-MM-dd', 'en');
  startDateBreathwork: any = formatDate(new Date().setDate(new Date().getDate()-14), 'yyyy-MM-dd', 'en');
  endDateBreathwork: any = formatDate(Date.now(), 'yyyy-MM-dd', 'en');
  previousDateQuests: any;
  currentDateQuests: any;
  previousDateMindfulness: any;
  currentDateMindfulness: any;
  // Metrics tab date tracking
  previousDateMetrics: any;
  currentDateMetrics: any;
  startDateMetrics: any = formatDate(new Date().setDate(new Date().getDate()-7), 'yyyy-MM-dd', 'en');
  endDateMetrics: any = formatDate(Date.now(), 'yyyy-MM-dd', 'en');
  activeButtonMetrics: string | null = null;
  globalStartDate: any;
  globalEndDate: any;
  // Nutrition date tracking
  nutritionStartDate: any;
  nutritionEndDate: any;
  selectedNutritionType: string | null = null;
  healthMetrics: any;
  selectedFoodLogId: string | null = null;
  // Health Tools base URLs from environment
  //bloodReportToolBaseUrl: string = environment.bloodReportToolUrl;
  //glucoseDataToolBaseUrl: string = environment.glucoseDataToolUrl;
  //biweeklyReportToolBaseUrl: string = environment.biweeklyReportToolUrl;
constructor(private dashboard:MemberDashboardService,private route:ActivatedRoute, private router: Router,private toast:ToastService) {
  var d = new Date();
  var p = new Date(new Date().setDate(new Date().getDate()-1));
  var pBmi = new Date(new Date().setDate(new Date().getDate()-7));
  var pScore = new Date(new Date().setDate(new Date().getDate()-7));
  var pSleep = new Date(new Date().setDate(new Date().getDate()-7));
  var pActivity = new Date(new Date().setDate(new Date().getDate()-7));
  this.currentDate= d
  this.previousDate= p;
  this.currentDateGS= d
  this.currentDateNU= d
  this.previousDateNU= p
  this.previousDateSL= p
  this.currentDateSL= d
  this.previousDateAC= p
  this.currentDateAC= d
  this.previousDateBmi= pBmi
  this.currentDateBmi= d
  this.previousDateScore= pScore
  this.currentDateScore= d
  this.previousDateSleep= pSleep
  this.currentDateSleep= d
  this.previousDateActivity= pActivity
  this.currentDateActivity= d
  // Initialize metrics date pickers to last 7 days so the UI date inputs are populated
  this.previousDateMetrics = new Date(new Date().setDate(new Date().getDate()-7));
  this.currentDateMetrics = d;
  this.nutritionStartDate = this.startDate;
  this.nutritionEndDate = this.endDate;
  this.globalStartDate = this.previousDate;
  this.globalEndDate = this.currentDate;
  // Initialize quests and mindfulness dates
  const pQuests = new Date(new Date().setDate(new Date().getDate() - 7));
  this.previousDateQuests = pQuests;
  this.currentDateQuests = d;
  this.previousDateMindfulness = pQuests;
  this.currentDateMindfulness = d;
}

ngOnInit(): void {
  const { stateObj } = window.history.state;
  this.stateObj = stateObj;
  if (stateObj) {
    this.applyNavigationState(stateObj);
  }
  this.getMemberById();
  this.getMemberDeviceInfo();
  this.getMemberPlanStatus();
  this.getLabWork();
    this.getVitalData(formatDate(new Date(), 'yyyy-MM-dd', 'en'));
  this.loadMainTabData(this.selectedMainTab);
}

public extractData(date: any):void {
    this.getMemberScore(date);
    this.getVitalData(date);
}
getMemberById(){
  this.dashboard.getMemberById(this.memberId).subscribe(response => {    
      this.memberList = response;
      this.memberList = this.memberList.result;
  });
}

getMemberDeviceInfo(){
  this.dashboard.getMemberDeviceInfo(this.memberId).subscribe(response => {
      this.deviceInfo = response;
  });
}

getMemberPlanStatus(){
  this.dashboard.getMemberPlanStatus(this.memberId).subscribe(response => {
      this.planStatus = response?.result ?? response;
  });
}

getMemberScore(data:any){
  this.dashboard.getMemberScore(this.memberId,data).subscribe(response => {
    this.scores = response;
    this.scores = this.scores.result;
});
}

getLabWork(){
  this.dashboard.getLabWork(this.memberId).subscribe(response => {    
    this.labList = response;
    this.labList = this.labList.result;
    this.labList.forEach((lab:any) => {
      if(lab.reportName == null || lab.reportName == ''){
        if(lab.type == 'labReport'){
          let n = lab.uploadFileURL.split('/').pop();
          lab.reportName = n.substring(n.indexOf('_')+1,n.length);;
        }else{ 
          lab.reportName = lab.uploadFileURL.split('/').pop();
        }
      }
    });
  });
}

getVitalData(data:any){
  this.dashboard.getVital(this.memberId,data).subscribe(response => {    
    this.vitalDetails = response;
    this.vitalDetails = this.vitalDetails.result;
});
}

  filterByDate(StartDate:HTMLInputElement,endDate:HTMLInputElement){
     if(StartDate.value != '' && endDate.value != ''){
      // Reset active button when using date picker
      this.activeButtonGlucose = null;
      const startDateStr = formatDate(StartDate.value, 'yyyy-MM-dd', 'en');
      const endDateStr = formatDate(endDate.value, 'yyyy-MM-dd', 'en');
      this.startDate = startDateStr;
      this.endDate = endDateStr;
       this.getGlucose(startDateStr, endDateStr);
       this.getGlucoseSummary(startDateStr, endDateStr);
       this.getGlucoseHealthMetrics(startDateStr, endDateStr);
     }
  }

  setTimePeriod(period: string) {
    // Set active button
    this.activeButtonGlucose = period;
    
    const today = new Date();
    let startDate: Date;
    
    switch (period) {
      case '1week':
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        break;
      case '2weeks':
        startDate = new Date(today.getTime() - (14 * 24 * 60 * 60 * 1000));
        break;
      case '1month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        break;
      case '3months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        break;
      default:
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    }
    
    // Update the date picker values
    this.previousDate = startDate;
    this.currentDate = today;
    
    // Format dates for API calls - use 'yyyy' instead of 'Y' to avoid ISO week-year issues
    const startDateStr = formatDate(startDate, 'yyyy-MM-dd', 'en');
    const endDateStr = formatDate(today, 'yyyy-MM-dd', 'en');
    
    // Update internal date variables
    this.startDate = startDateStr;
    this.endDate = endDateStr;
    
    // Fetch glucose data for the selected period
    this.getGlucose(startDateStr, endDateStr);
    this.getGlucoseSummary(startDateStr, endDateStr);
    this.getGlucoseHealthMetrics(startDateStr, endDateStr);
  }

  filterByDateBmi(StartDate:HTMLInputElement,endDate:HTMLInputElement){
    if(StartDate.value != '' && endDate.value != ''){
     // Reset active button when using date picker
     this.activeButtonBmi = null;
     const startDateStr = formatDate(StartDate.value, 'yyyy-MM-dd', 'en');
     const endDateStr = formatDate(endDate.value, 'yyyy-MM-dd', 'en');
     this.startDateBmi = startDateStr;
     this.endDateBmi = endDateStr;
    } 
  }

  setTimePeriodBmi(period: string) {
    // Set active button
    this.activeButtonBmi = period;
    
    const today = new Date();
    let startDate: Date;
    
    switch (period) {
      case '1week':
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        break;
      case '2weeks':
        startDate = new Date(today.getTime() - (14 * 24 * 60 * 60 * 1000));
        break;
      case '1month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        break;
      case '3months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        break;
      default:
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    }
    
    // Update the date picker values
    this.previousDateBmi = startDate;
    this.currentDateBmi = today;
    
    // Format dates for API calls
    const startDateStr = formatDate(startDate, 'yyyy-MM-dd', 'en');
    const endDateStr = formatDate(today, 'yyyy-MM-dd', 'en');
    
    // Update internal date variables for BMI
    this.startDateBmi = startDateStr;
    this.endDateBmi = endDateStr;
  }

  filterByDateScore(StartDate:HTMLInputElement,endDate:HTMLInputElement){
    if(StartDate.value != '' && endDate.value != ''){
     // Reset active button when using date picker
     this.activeButtonScore = null;
     const startDateStr = formatDate(StartDate.value, 'yyyy-MM-dd', 'en');
     const endDateStr = formatDate(endDate.value, 'yyyy-MM-dd', 'en');
     this.startDateScore = startDateStr;
     this.endDateScore = endDateStr;
    } 
  }

  setTimePeriodScore(period: string) {
    // Set active button
    this.activeButtonScore = period;
    
    const today = new Date();
    let startDate: Date;
    
    switch (period) {
      case '1week':
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        break;
      case '2weeks':
        startDate = new Date(today.getTime() - (14 * 24 * 60 * 60 * 1000));
        break;
      case '1month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        break;
      case '3months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        break;
      default:
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    }
    
    // Update the date picker values
    this.previousDateScore = startDate;
    this.currentDateScore = today;
    
    // Format dates for API calls
    const startDateStr = formatDate(startDate, 'yyyy-MM-dd', 'en');
    const endDateStr = formatDate(today, 'yyyy-MM-dd', 'en');
    
    // Update internal date variables for Score
    this.startDateScore = startDateStr;
    this.endDateScore = endDateStr;
  }

  filterByDateSleep(StartDate:HTMLInputElement,endDate:HTMLInputElement){
    if(StartDate.value != '' && endDate.value != ''){
     // Reset active button when using date picker
     this.activeButtonSleep = null;
     const startDateStr = formatDate(StartDate.value, 'yyyy-MM-dd', 'en');
     const endDateStr = formatDate(endDate.value, 'yyyy-MM-dd', 'en');
     this.startDateSleep = startDateStr;
     this.endDateSleep = endDateStr;
    } 
  }

  setTimePeriodSleep(period: string) {
    // Set active button
    this.activeButtonSleep = period;
    
    const today = new Date();
    let startDate: Date;
    
    switch (period) {
      case '1week':
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        break;
      case '2weeks':
        startDate = new Date(today.getTime() - (14 * 24 * 60 * 60 * 1000));
        break;
      case '1month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        break;
      case '3months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        break;
      default:
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    }
    
    // Update the date picker values
    this.previousDateSleep = startDate;
    this.currentDateSleep = today;
    
    // Format dates for API calls
    const startDateStr = formatDate(startDate, 'yyyy-MM-dd', 'en');
    const endDateStr = formatDate(today, 'yyyy-MM-dd', 'en');
    
    // Update internal date variables for Sleep
    this.startDateSleep = startDateStr;
    this.endDateSleep = endDateStr;
  }

  filterByDateActivity(StartDate:HTMLInputElement,endDate:HTMLInputElement){
    if(StartDate.value != '' && endDate.value != ''){
     // Reset active button when using date picker
     this.activeButtonActivity = null;
     const startDateStr = formatDate(StartDate.value, 'yyyy-MM-dd', 'en');
     const endDateStr = formatDate(endDate.value, 'yyyy-MM-dd', 'en');
     this.startDateActivity = startDateStr;
     this.endDateActivity = endDateStr;
    } 
  }

  setTimePeriodActivity(period: string) {
    // Set active button
    this.activeButtonActivity = period;
    
    const today = new Date();
    let startDate: Date;
    
    switch (period) {
      case '1week':
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        break;
      case '2weeks':
        startDate = new Date(today.getTime() - (14 * 24 * 60 * 60 * 1000));
        break;
      case '1month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        break;
      case '3months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        break;
      default:
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    }
    
    // Update the date picker values
    this.previousDateActivity = startDate;
    this.currentDateActivity = today;
    
    // Format dates for API calls
    const startDateStr = formatDate(startDate, 'yyyy-MM-dd', 'en');
    const endDateStr = formatDate(today, 'yyyy-MM-dd', 'en');
    
    // Update internal date variables for Activity
    this.startDateActivity = startDateStr;
    this.endDateActivity = endDateStr;
  }

  filterByDateMetrics(StartDate:HTMLInputElement,endDate:HTMLInputElement){
    if(StartDate.value != '' && endDate.value != ''){
     // Reset active button when using date picker
     this.activeButtonMetrics = null;
     const startDateStr = formatDate(StartDate.value, 'yyyy-MM-dd', 'en');
     const endDateStr = formatDate(endDate.value, 'yyyy-MM-dd', 'en');
     this.startDateMetrics = startDateStr;
     this.endDateMetrics = endDateStr;
    } 
  }

  setTimePeriodMetrics(period: string) {
    // Set active button
    this.activeButtonMetrics = period;
    
    const today = new Date();
    let startDate: Date;
    
    switch (period) {
      case '1week':
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        break;
      case '2weeks':
        startDate = new Date(today.getTime() - (14 * 24 * 60 * 60 * 1000));
        break;
      case '1month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        break;
      case '3months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        break;
      default:
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    }
    
    // Update the date picker values
    this.previousDateMetrics = startDate;
    this.currentDateMetrics = today;
    
    // Format dates for API calls
    const startDateStr = formatDate(startDate, 'yyyy-MM-dd', 'en');
    const endDateStr = formatDate(today, 'yyyy-MM-dd', 'en');
    
    // Update internal date variables for Metrics
    this.startDateMetrics = startDateStr;
    this.endDateMetrics = endDateStr;
  }

  setTimePeriodNutrition(period: string) {
    // Set active button
    this.activeButtonNutrition = period;
    
    const today = new Date();
    let startDate: Date;
    
    switch (period) {
      case '1week':
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        break;
      case '2weeks':
        startDate = new Date(today.getTime() - (14 * 24 * 60 * 60 * 1000));
        break;
      case '1month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        break;
      case '3months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        break;
      default:
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    }
    
    // Update the date picker values
    this.previousDateNU = startDate;
    this.currentDateNU = today;
    
    // Format dates for API calls
    const startDateStr = formatDate(startDate, 'yyyy-MM-dd', 'en');
    const endDateStr = formatDate(today, 'yyyy-MM-dd', 'en');
    
    // Store nutrition dates
    this.nutritionStartDate = startDateStr;
    this.nutritionEndDate = endDateStr;
    
    // Fetch nutrition data for the selected period
    this.extractNutData({ value: startDateStr }, { value: endDateStr }, false);
  }

  refreshNutritionData() {
    if (this.memberId && this.nutritionStartDate && this.nutritionEndDate) {
      this.getNutritionData(this.nutritionStartDate, this.nutritionEndDate);
    }
  }

  onMainTabSelect(tab: 'scores' | 'glucose' | 'vitals' | 'lifestyle' | 'mindpillar' | 'bloodreporthistory'): void {
    this.selectedMainTab = tab;
    this.loadMainTabData(tab);
  }

  onMindPillarTabSelect(tab: 'quests' | 'moodcheckin' | 'breathwork' | 'mindfulness' | 'journal' | 'habits'): void {
    this.selectedMindPillarTab = tab;
  }

  onLifestyleTabSelect(tab: 'nutrition' | 'sleep' | 'activity' | 'metrics' | 'waterlog'): void {
    this.selectedLifestyleTab = tab;
    this.loadLifestyleTabData(tab as any);
  }

  onBloodReportHistoryLoadingChanged(isLoading: boolean): void {
    this.isLoading = isLoading ? 1 : 2;
  }


  // Dashboard date range picker is disabled; logic kept for reference.
  // onGlobalDateRangeChange(startInput: HTMLInputElement, endInput: HTMLInputElement): void {
  //   if (startInput.value && endInput.value) {
  //     const startStr = formatDate(startInput.value, 'yyyy-MM-dd', 'en');
  //     const endStr = formatDate(endInput.value, 'yyyy-MM-dd', 'en');
  //     this.applyGlobalDateRange(startStr, endStr);
  //   }
  // }

  private loadMainTabData(tab: 'scores' | 'glucose' | 'vitals' | 'lifestyle' | 'mindpillar' | 'bloodreporthistory'): void {
    this.isLoading = (tab === 'glucose' || tab === 'bloodreporthistory') ? 1 : 2;

    switch (tab) {
      case 'scores':
        this.getMemberScore(formatDate(new Date(), 'yyyy-MM-dd', 'en'));
        break;
      case 'glucose':
        this.loadGlucoseTabData();
        break;
      case 'vitals':
        break;
      case 'lifestyle':
        this.loadLifestyleTabData(this.selectedLifestyleTab);
        break;
      case 'mindpillar':
        break;
      case 'bloodreporthistory':
        break;
    }
  }

  private loadGlucoseTabData(): void {
    this.getGlucose(this.startDate, this.endDate);
    this.getGlucoseSummary(this.startDate, this.endDate);
    this.getGlucoseHealthMetrics(this.startDate, this.endDate);
  }

  private loadLifestyleTabData(tab: 'nutrition' | 'sleep' | 'activity' | 'metrics' | 'waterlog'): void {
    if (tab === 'nutrition') {
      // Nutrition component will load data automatically via ngOnChanges when inputs change
      // No need to call getNutritionData here to avoid duplicate API calls
    } else if (tab === 'metrics') {
      // ensure metrics date ranges are initialized
      this.startDateMetrics = this.startDateMetrics || this.startDate;
      this.endDateMetrics = this.endDateMetrics || this.endDate;
      // CombinedMetrics component will load its own data using inputs
    } else if (tab === 'waterlog') {
      this.dashboard.getHydrationGoalsByMemberId(this.memberId).subscribe(response => {
        this.hydrationGoalData = response;
      });
    }
  }

  // private applyGlobalDateRange(startStr: string, endStr: string): void {
  //   const startDateObj = new Date(startStr);
  //   const endDateObj = new Date(endStr);

  //   this.globalStartDate = startDateObj;
  //   this.globalEndDate = endDateObj;

  //   // Reset active buttons for custom range
  //   this.activeButtonScore = null;
  //   this.activeButtonGlucose = null;
  //   this.activeButtonBmi = null;
  //   this.activeButtonNutrition = null;
  //   this.activeButtonSleep = null;
  //   this.activeButtonActivity = null;

  //   // Update internal ranges used by sections
  //   this.startDateScore = startStr;
  //   this.endDateScore = endStr;
  //   this.startDate = startStr;
  //   this.endDate = endStr;
  //   this.startDateBmi = startStr;
  //   this.endDateBmi = endStr;
  //   this.startDateSleep = startStr;
  //   this.endDateSleep = endStr;
  //   this.startDateActivity = startStr;
  //   this.endDateActivity = endStr;
  //   this.nutritionStartDate = startStr;
  //   this.nutritionEndDate = endStr;
  //   this.startDateQuests = startStr;
  //   this.endDateQuests = endStr;
  //   this.startDateMindfulness = startStr;
  //   this.endDateMindfulness = endStr;
  //   this.startDateBreathwork = startStr;
  //   this.endDateBreathwork = endStr;
  //   this.startDateMetrics = startStr;
  //   this.endDateMetrics = endStr;

  //   // Update date-picker bound objects
  //   this.previousDateScore = startDateObj;
  //   this.currentDateScore = endDateObj;
  //   this.previousDate = startDateObj;
  //   this.currentDate = endDateObj;
  //   this.previousDateBmi = startDateObj;
  //   this.currentDateBmi = endDateObj;
  //   this.previousDateSleep = startDateObj;
  //   this.currentDateSleep = endDateObj;
  //   this.previousDateActivity = startDateObj;
  //   this.currentDateActivity = endDateObj;
  //   this.previousDateNU = startDateObj;
  //   this.currentDateNU = endDateObj;
  //   this.previousDateQuests = startDateObj;
  //   this.currentDateQuests = endDateObj;
  //   this.previousDateMindfulness = startDateObj;
  //   this.currentDateMindfulness = endDateObj;

  //   // Refresh data for all sections
  //   this.isLoading = this.selectedMainTab === 'glucose' ? 1 : 2;
  //   this.getMemberScore(endStr);
  //   this.getVitalData(endStr);
  //   this.getGlucose(startStr, endStr);
  //   this.getGlucoseSummary(startStr, endStr);
  //   this.getNutritionData(startStr, endStr);
  //   this.getSleepData(startStr, endStr);
  //   this.getActivityData(startStr, endStr);
  //   this.getHealthMetrics(startStr, endStr);
  // }

  private applyNavigationState(stateObj: any): void {
    if (!stateObj) {
      return;
    }
    if (stateObj.selectedMainTab) {
      this.selectedMainTab = stateObj.selectedMainTab;
    }
    if (stateObj.selectedLifestyleTab) {
      this.selectedLifestyleTab = stateObj.selectedLifestyleTab;
    }
    if (stateObj.selectedMindPillarTab) {
      this.selectedMindPillarTab = stateObj.selectedMindPillarTab;
    }
    if (stateObj.nutritionStartDate && stateObj.nutritionEndDate) {
      this.nutritionStartDate = stateObj.nutritionStartDate;
      this.nutritionEndDate = stateObj.nutritionEndDate;
      this.previousDateNU = new Date(stateObj.nutritionStartDate);
      this.currentDateNU = new Date(stateObj.nutritionEndDate);
    }
    if (stateObj.selectedNutritionType) {
      this.selectedNutritionType = stateObj.selectedNutritionType;
    }
    if (stateObj.selectedFoodLogId) {
      this.selectedFoodLogId = stateObj.selectedFoodLogId;
    }
  }

  getGlucoseSummary(startDate: any, endDate: any){
    this.dashboard.getGlucoseSummary(this.memberId, startDate, endDate).subscribe(response => {    
      this.glucoseSummary = response;
      this.glucoseSummary = this.glucoseSummary.result;
  });

  }
  getGlucose(startDate:any,endDate:any){
    this.isLoading=1;
    // Fetch glucose readings and the medicines range together and assign
    // glucoseDetails exactly once. Previously these were two independent
    // subscriptions where the medicines-range response re-assigned
    // glucoseDetails a second time (via a shallow {...spread}) after the
    // child <app-glucose> had already processed the first assignment. That
    // second, delayed assignment re-triggered the chart's ngOnChanges while
    // reusing the same `readings` array reference, which duplicated
    // timeline entries (medication/food log/sleep/workout) and forced a
    // second full chart rebuild - if a legend toggle click landed in that
    // window, it got wiped out by the rebuild, making it look like the
    // toggle "didn't work".
    forkJoin({
      glucose: this.dashboard.getGlucose(this.memberId, startDate, endDate),
      medicinesRange: this.dashboard.getGlucoseMedicinesRange(this.memberId, startDate, endDate),
    }).subscribe(({ glucose, medicinesRange }) => {
      if (glucose == 1) {
        this.isLoading = 2;
        this.toast.errorMessage('Error While fetching glucose readings. Please try again!');
        return;
      }

      const result = (glucose as any).result;
      const medicinesByTime = (medicinesRange as any)?.medicinesByTime || {};
      this.glucoseMedicinesRange = medicinesRange;
      this.glucoseDetails = {
        ...result,
        medicinesRange: medicinesRange,
        medicinesByTime: medicinesByTime,
      };

      this.insights=[];
      let k=0;
      let m=0;
      this.insights.push([]);
      for(let j=0;j< this.glucoseDetails.insights.length;j++){

          if(m > 2){
            this.insights.push([]);
            m=1;
            k++;

          }else{
            m++;
          }
          this.insights[k].push(this.glucoseDetails.insights[j]);
      }


      this.timeLines=[];
      k=0;
      m=0;
      this.timeLines.push([]);
      for(let j=0;j< this.glucoseDetails.timeLine.length;j++){

          if(m > 2){
            this.timeLines.push([]);
            m=1;
            k++;

          }else{
            m++;
          }
          this.timeLines[k].push(this.glucoseDetails.timeLine[j]);
      }
      this.isLoading=2;
    });
  }

  extractNutData( startDate:any,endDate:any, resetActiveButton: boolean = true){
     if(startDate.value != '' && endDate.value != ''){
      // Reset active button when using date picker (but not when called from time period buttons)
      if (resetActiveButton) {
        this.activeButtonNutrition = null;
      }
      // Only update dates - Nutrition component will load data automatically via ngOnChanges
      this.nutritionStartDate = formatDate(startDate.value, 'yyyy-MM-dd','en-US');
      this.nutritionEndDate = formatDate(endDate.value, 'yyyy-MM-dd','en-US');
      // Removed getNutritionData call to avoid duplicate API calls
      // Child component (app-nutrition) handles API call via ngOnChanges
     }
  }
  extractSleepData(startDate:any,endDate:any){
     if(startDate.value != '' && endDate.value != ''){
      this.getSleepData(formatDate(startDate.value, 'yyyy-MM-dd','en-US'),formatDate(endDate.value, 'yyyy-MM-dd','en-US'));
     }
  }
  extractActivityData(startDate:any,endDate:any){
     if(startDate.value != '' && endDate.value != ''){
      this.getActivityData(formatDate(startDate.value, 'yyyy-MM-dd','en-US'),formatDate(endDate.value, 'yyyy-MM-dd','en-US'));
     }
  }
  extractHealthMetricsData(startDate:any,endDate:any){
     if(startDate.value != '' && endDate.value != ''){
      this.getHealthMetrics(formatDate(startDate.value, 'yyyy-MM-dd','en-US'),formatDate(endDate.value, 'yyyy-MM-dd','en-US'));
     }
  }
   getSleepData(startDate:any,endDate:any){
    this.dashboard.getSleepData(this.memberId,startDate,endDate).subscribe(response => {    
        this.sleep = response;
        this.sleep = this.sleep.result;
    });
   }
   getNutritionData(startDate:any,endDate:any){
    this.dashboard.getLifeStyle(this.memberId,startDate,endDate).subscribe(response => {    
        this.lifeStyle = response;
        this.lifeStyle = this.lifeStyle.result;
    });
  }
  getActivityData(startDate:any,endDate:any){
    this.dashboard.getActivity(this.memberId,startDate,endDate).subscribe(response => {    
        this.activity = response;
        this.activity = this.activity.result;
    });
  }

  getHealthMetrics(startDate:any,endDate:any){
    this.dashboard.getHealthMetrics(this.memberId,startDate,endDate).subscribe(response => {
        // Support both legacy and new API shapes
        // Legacy: { result: [...] }
        // New:    { healthMetrics: { heartrate: [...], rhr: [...], hrv: [...] }, ... }
        this.healthMetrics = response;
        if (this.healthMetrics && this.healthMetrics.result) {
          this.healthMetrics = this.healthMetrics.result;
        } else if (this.healthMetrics && this.healthMetrics.healthMetrics) {
          this.healthMetrics = this.healthMetrics.healthMetrics;
        }
    });
  }

  // Same /healthData/healthMetrics endpoint as getHealthMetrics() above, but kept on its own
  // field and fetched with the Glucose Mapping tab's own date range, for the glucose chatbot
  // payload - independent of the Lifestyle tab's healthMetrics date picker.
  private getGlucoseHealthMetrics(startDate: any, endDate: any): void {
    this.dashboard.getHealthMetrics(this.memberId, startDate, endDate).subscribe((response: any) => {
      let healthMetricsData = response;
      if (healthMetricsData && healthMetricsData.result) {
        healthMetricsData = healthMetricsData.result?.healthMetrics ?? healthMetricsData.result;
      } else if (healthMetricsData && healthMetricsData.healthMetrics) {
        healthMetricsData = healthMetricsData.healthMetrics;
      }
      this.glucoseHealthMetricsData = healthMetricsData;
    });
  }

  getMindfulnessData(){
    this.dashboard.getMindfulnessData(this.memberId).subscribe(response => {    
        this.mindfulnessData = response;
        console.log('Mindfulness Data:', this.mindfulnessData);
    });
  }
  changeTimeFormat(hours: any, minutes: any) {



    // Check whether AM or PM
    let newformat = hours >= 12 ? 'PM' : 'AM';

    // Find current hour in AM-PM Format
    hours = hours % 12;

    // To display "0" as "12"
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '' + minutes : minutes;

    return hours + ':' + minutes + ' ' + newformat;
  }
  backBtn(){
  this.router.navigate(['/members'],{state:{stateObj:this.stateObj}});
  }

  /* Health Tools methods - Commented out, now available in separate Health Tools component */
  /*
  // Generates a simple blood report tool link with only essential member information
  generateBloodReportToolLink(): string {
    if (!this.memberList || !this.memberList.firstName || !this.memberList.lastName || !this.memberId) {
      return this.bloodReportToolBaseUrl;
    }

    const params = new URLSearchParams({
      first_name: this.memberList.firstName.trim(),
      last_name: this.memberList.lastName.trim(),
      member_id: this.memberId.toString()
    });

    return `${this.bloodReportToolBaseUrl}/?${params.toString()}`;
  }

  // Opens the blood report tool in a new tab
  openBloodReportTool(): void {
    const url = this.generateBloodReportToolLink();
    window.open(url, '_blank');
  }

  // Generates a simple glucose data extraction tool link with only essential member information
  generateGlucoseDataToolLink(): string {
    if (!this.memberList || !this.memberList.firstName || !this.memberList.lastName || !this.memberId) {
      return this.glucoseDataToolBaseUrl;
    }

    const params = new URLSearchParams({
      first_name: this.memberList.firstName.trim(),
      last_name: this.memberList.lastName.trim(),
      member_id: this.memberId.toString()
    });

    return `${this.glucoseDataToolBaseUrl}?${params.toString()}`;
  }

  // Opens the glucose data extraction tool in a new tab
  openGlucoseDataTool(): void {
    const url = this.generateGlucoseDataToolLink();
    window.open(url, '_blank');
  }

  // Generates a biweekly report tool link with member ID in the path
  generateBiweeklyReportToolLink(): string {
    if (!this.memberId) {
      return this.biweeklyReportToolBaseUrl;
    }

    // Create URL with member ID in the path: /user/{memberId}/reports
    return `${this.biweeklyReportToolBaseUrl}${this.memberId}/reports`;
  }

  // Opens the biweekly report tool in a new tab
  openBiweeklyReportTool(): void {
    const url = this.generateBiweeklyReportToolLink();
    window.open(url, '_blank');
  }
  */
}
